import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MyProjectsTable from "../../components/myProjects/Tables/MyProjectsTable";
import routes from "../../config/routes/routes";
import projectThunks from "../../config/thunks/businessDevAndPartnerships/projects/projects.thunks";
import logDetailThunks from "../../config/thunks/settings/logDetails.thunks";
import { Tabs } from "antd";

const MyProjects = () => {
  //varibles and initializations
  const dispatch = useDispatch();
  const { myProjectsSuccess, myProjects } = useSelector(
    (state) => state.projectsState
  );
  //ui
  //thunks
  const refreshData = () => dispatch(projectThunks.getMyProjects());
  const exportRecords = () => {
    dispatch(
      logDetailThunks.addLogDetails({
        created_at: new Date(),
        activity: "Exported My Projects Records",
        records: "myProjects",
      })
    );
  };
  //use effects
  useEffect(() => {
    document.title = routes.myProjects.title;
    if (!myProjectsSuccess) dispatch(projectThunks.getMyProjects());
  }, [myProjectsSuccess, dispatch]);
  return (
    <div className="container-fluid p-2">
      <h5 className="fw-bold text-uppercase">My Projects</h5>
      <Tabs
        type="card"
        tabBarStyle={{
          marginBottom: "0",
        }}
        items={[
          {
            label: "ACTIVE PROJECTS",
            key: "activeProjects",
            children: (
              <MyProjectsTable
                data={myProjects.activeProjects}
                handleRefreshTable={refreshData}
                handleExportRecords={exportRecords}
              />
            ),
          },
          {
            label: "COMPLETED PROJECTS",
            key: "completedProjects",
            children: (
              <MyProjectsTable
                data={myProjects.completedProjects}
                handleRefreshTable={refreshData}
                handleExportRecords={exportRecords}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default MyProjects;
